// extracted by css-extract-rspack-plugin
export default {"edit-btn":"uLufG2","editBtn":"uLufG2","disabled":"KtyLWg"};